import { useEffect, useState } from 'react';
import './../../styles/Editor.css';
import EditorLoading from './EditorLoading.js';
import config from '../../constants/config.js';

function EditorVersions( { versions , handle , setChangesMade } ) {
    const [ versionList , setVersionList ] = useState( versions?.values || [] );
    const [ versionPagination , setVersionPagination ]= useState( versions?.pagination );
    const [ loadingVersions , setLoadingVersions ] = useState( true );
    const [ versionElements , setVersionElements ] = useState( [] );
    const [ reverting , setReverting ] = useState( false );
    const [ loadingNextPage, setLoadingNextPage ] = useState( false );

    useEffect( () => {
        async function loadView() {
            const vEls = [];
            for ( let i = 0; i < versionList.length; i++ ) {
                const idOfVersion = versionList[i].id;
                const versionName = versionList[i].name;
                const date = convertDate( versionList[i]?.date );
                const email = versionList[i]?.created_by;
                const profilePicture = await getProfilePicture( email , null );
                const status = versionList[i].status;
                const isCurrentVersion = status === "Published";
        
                const versionEl = (
                    <div className="version-history-item" key={idOfVersion}>
                        <div className="pic-wrap">
                            <img alt={versionName} className="profile-picture" width={100} height={100} src={ profilePicture } ></img>
                        </div>
                        <div className="content-wrap">
                            <div className="headings">
                                <h2 className="primary-heading">{ versionName }</h2>
                                <div className="secondary-heading">{ date }</div>
                            </div>
                            <div className="actions">
                                { isCurrentVersion &&
                                    <div className="v-btn current-version">Current Live Version</div>
                                }

                                { !isCurrentVersion &&
                                    <button onClick={ () => { 
                                        revertToVersion( idOfVersion , handle );
                                    }} className="v-btn">
                                        <span>Revert</span>
                                        <svg width="10" height="10" viewBox="0 0 3 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M-4.54929e-07 5.28139L0.446176 5.72715L2.87639 3.29778C2.91556 3.25885 2.94665 3.21256 2.96786 3.16158C2.98908 3.11059 3 3.05591 3 3.00068C3 2.94545 2.98908 2.89077 2.96786 2.83979C2.94665 2.7888 2.91556 2.74251 2.87639 2.70358L0.446176 0.272949L0.000420095 0.718705L2.28134 3.00005L-4.54929e-07 5.28139Z" fill="#67A1FB"/>
                                        </svg>
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                );
        
                vEls.push( versionEl );
            }

            setVersionElements( vEls );
            setLoadingVersions( false );
        }
        
        setLoadingVersions( true );
        
        setVersionList( versions?.values || [] );
        setVersionPagination( versions?.pagination );
        loadView();
    } , [] )

    function convertDate( date ) {
        // take date string and convert it into MO/DD/YYYY
        const _date = new Date( date );
        const month = _date.getMonth() + 1;
        const day = _date.getDate();
        const year = _date.getFullYear();
        return `${month}/${day}/${year}`;
    }

    async function getProfilePicture( email , defaultProfileImage ) {
        const cleanedEmail = email.trim().toLowerCase();
        const msgBuffer = new TextEncoder().encode(cleanedEmail);
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        let url = `https://www.gravatar.com/avatar/${hashHex}`;
        if ( defaultProfileImage != null ) {
            const defaultImageUrl = encodeURIComponent( defaultProfileImage );
            url += `?d=${defaultImageUrl}`;
        }

        return url;
    }

    async function revertToVersion( versionId , productHandle ) {
        setReverting( true );

        try {
            const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/products/${encodeURIComponent( productHandle )}/revert/${encodeURIComponent( versionId )}`;
            const requestSettings = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({})
            };

            const response = await fetch( url , requestSettings );
            const data = await response.json();
            if ( data.errors.length > 0 ) {
                console.error( data.errors );
                setReverting( false );
            } else {
                setChangesMade( 0 );
                setReverting( false );
                window.location.reload();
            }
        } catch ( error ) {
            console.error( error );
            setReverting( false );
        }
        
        return;
    }

    async function getNextVersionPage() {
        if ( !versionPagination?.current_page || !versionPagination?.total_pages ) { 
            return;
        }
        
        if ( loadingNextPage || versionPagination.current_page >= versionPagination.total_pages ) { 
            return; 
        }

        setLoadingNextPage(true);

        try {
            const nextPage = versionPagination.current_page + 1;
            const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/products/${encodeURIComponent(handle)}/versions?page=${nextPage}&limit=25`;

            const response = await fetch(url);
            const data = await response.json();

            const newVersions = data.values || [];
            const updatedPagination = data.pagination;

            const newVersionElements = [];

            for (let i = 0; i < newVersions.length; i++) {
                const version = newVersions[i];
                const idOfVersion = version.id;
                const versionName = version.name;
                const date = convertDate(version?.date);
                const email = version?.created_by;
                const profilePicture = await getProfilePicture(email, null);
                const status = version.status;
                const isCurrentVersion = status === "Published";

                const versionEl = (
                    <div className="version-history-item" key={idOfVersion}>
                        <div className="pic-wrap">
                            <img alt={versionName} className="profile-picture" width={100} height={100} src={profilePicture} />
                        </div>
                        <div className="content-wrap">
                            <div className="headings">
                                <h2 className="primary-heading">{versionName} [{idOfVersion}]</h2>
                                <div className="secondary-heading">{date}</div>
                            </div>
                            <div className="actions">
                                {isCurrentVersion && <div className="v-btn current-version">Current Live Version</div>}
                                {!isCurrentVersion && (
                                    <button
                                        onClick={() => revertToVersion(idOfVersion, handle)}
                                        className="v-btn"
                                    >
                                        <span>Revert</span>
                                        <svg width="10" height="10" viewBox="0 0 3 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M-4.54929e-07 5.28139L0.446176 5.72715L2.87639 3.29778C2.91556 3.25885 2.94665 3.21256 2.96786 3.16158C2.98908 3.11059 3 3.05591 3 3.00068C3 2.94545 2.98908 2.89077 2.96786 2.83979C2.94665 2.7888 2.91556 2.74251 2.87639 2.70358L0.446176 0.272949L0.000420095 0.718705L2.28134 3.00005L-4.54929e-07 5.28139Z" fill="#67A1FB"/>
                                        </svg>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                );

                newVersionElements.push(versionEl);
            }

            setVersionElements(prev => [...prev, ...newVersionElements]);
            setVersionPagination(updatedPagination);
        } catch (error) {
            console.error("Failed to load next version page", error);
        } finally {
            setLoadingNextPage(false);
        }
    }

    return(
        <section className="versions-body-section">
            <div className="versions-body">
                <h1 className="version-header">Version History</h1>
            
                { reverting && 
                    <EditorLoading/>
                }

                { !reverting && versionElements.length <= 0 && loadingVersions && <div>Getting Version history...</div> }
                { !reverting && versionElements.length > 0 && !loadingVersions && 
                    <div className="version-history-list">
                        { versionElements.map( (el) => el ) }
                        { versionPagination != null && versionPagination?.on_last_page == false &&
                            <div className="pagination">
                                <button disabled={loadingNextPage} className="show-more" onClick={getNextVersionPage}>
                                    { loadingNextPage ? "loading..." : "Show More" }
                                </button>
                            </div>
                        }
                    </div> 
                }
                { !reverting && versionElements.length <= 0 && !loadingVersions && <div className="no-version-message">No versions were found for the current product.</div> }
            </div>
        </section>
    );
}

export default EditorVersions;